import Ajax from "../utils/ajax";

export default {
  namespaced: true,

  actions: {
    async changePassword({ commit }, { data }) {
      try {
        const resp = await Ajax.put("/api/v1/Auth/changePassword", data);
        return Promise.resolve(resp.data);
      } catch (e) {
        return Promise.reject(e.response.data);
      }
    },
  },
};
